import { render } from "./orgToUser.vue?vue&type=template&id=da55be04"
import script from "./orgToUser.vue?vue&type=script&lang=js"
export * from "./orgToUser.vue?vue&type=script&lang=js"

import "./orgToUser.vue?vue&type=style&index=0&id=da55be04&lang=scss"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__